import { EuiSpacer } from '@elastic/eui';
import QICards from 'components/Indoor_Cameras/IN-8003_HD/Quick_Installation/QICards';
import NavButtons from 'components/Indoor_Cameras/IN-8003_HD/NavButtons';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  EuiSpacer,
  QICards,
  NavButtons,
  BreadCrumbs,
  SEOHelmet,
  React
};